import { FC } from 'react'
import { Controller } from 'react-hook-form'

import SelectField from '@/components/select-field'
import { Input } from '@/components/ui/input'
import FormGroup from '@/core/components/FormGroup'
import { CheckboxGroupField } from './CheckboxGroupField'
import {
  CARD_NETWORKS,
  CONFIG_AUTH_METHODS,
  COUNTRY_CODE_OPTIONS,
} from './constants'
import { PayConfigFieldsProps } from './types'

export const GooglePayFields: FC<PayConfigFieldsProps> = ({
  namePrefix,
  control,
  register,
  configErrors,
}) => {
  return (
    <div className="space-y-4 p-4 border border-monochrome-120 rounded-2xl">
      <h4 className="text-sm font-medium text-monochrome-1">
        Google Pay Configuration
      </h4>

      <div className="flex gap-4">
        <Controller
          name={`${namePrefix}.countryCode`}
          control={control}
          render={({ field }) => (
            <FormGroup
              label="Country Code"
              error={configErrors?.countryCode?.message}
              className="flex-1"
            >
              <SelectField
                outline
                triggerClassName="h-[44px] rounded-2xl"
                placeholder="Select Country"
                options={COUNTRY_CODE_OPTIONS}
                value={field.value}
                onValueChange={field.onChange}
              />
            </FormGroup>
          )}
        />
      </div>

      <div className="flex gap-4">
        <FormGroup
          label="Environment"
          error={configErrors?.environment?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.environment?.message}
            {...register(`${namePrefix}.environment`)}
            placeholder="Environment"
          />
        </FormGroup>
        <FormGroup
          label="Gateway"
          error={configErrors?.gateway?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.gateway?.message}
            {...register(`${namePrefix}.gateway`)}
            placeholder="Gateway"
          />
        </FormGroup>
      </div>

      <div className="flex gap-4">
        <FormGroup
          label="Merchant Name"
          error={configErrors?.merchantName?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.merchantName?.message}
            {...register(`${namePrefix}.merchantName`)}
            placeholder="Merchant Name"
          />
        </FormGroup>
        <FormGroup
          label="Merchant ID"
          error={configErrors?.merchantId?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.merchantId?.message}
            {...register(`${namePrefix}.merchantId`)}
            placeholder="Merchant ID"
          />
        </FormGroup>
      </div>

      <div className="flex gap-4">
        <FormGroup
          label="Stripe Version"
          error={configErrors?.stripeVersion?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.stripeVersion?.message}
            {...register(`${namePrefix}.stripeVersion`)}
            placeholder="Stripe Version"
          />
        </FormGroup>
        <FormGroup
          label="Stripe Publishable Key"
          error={configErrors?.stripePublishableKey?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.stripePublishableKey?.message}
            {...register(`${namePrefix}.stripePublishableKey`)}
            placeholder="Stripe Publishable Key"
          />
        </FormGroup>
      </div>

      <CheckboxGroupField
        name={`${namePrefix}.cardNetworks`}
        control={control}
        label="Card Networks"
        options={CARD_NETWORKS}
      />
      <CheckboxGroupField
        name={`${namePrefix}.authMethods`}
        control={control}
        label="Auth Methods"
        options={CONFIG_AUTH_METHODS}
      />
    </div>
  )
}
